import CustomCheckbox from "../CustomCheckbox";
import { showGrade } from "../../utils/textUtils";
import ErrorIcon from "@mui/icons-material/Error";

const thStyle = {
  padding: "10px",
  fontSize: "0.78rem",
  fontWeight: 700,
  color: "#7A8490",
};
const tdStyle = { padding: "10px", fontSize: "0.9rem" };

const SelectedStudentList = ({
  selectedStudents,
  handleAddStudents,
  handleSelectStudent,
  handleSelectAllStudent,
  isEditMode = false,
}) => {
  const count = isEditMode
    ? selectedStudents.filter((student) => student.is_new).length
    : selectedStudents.length;
  const disabled = selectedStudents.length === 0;

  return (
    <div>
      <div
        style={{
          margin: "10px 0px",
          fontSize: "0.88rem",
          fontWeight: 800,
          color: "#3A434E",
        }}
      >
        선택된 학생{" "}
        <span style={{ color: "#00A396" }}>({selectedStudents.length})</span>
      </div>
      <button
        style={{
          padding: "12px",
          backgroundColor: disabled ? "#B9C1C9" : "#0E141B",
          color: "#FFFFFF",
          fontSize: "0.92rem",
          fontWeight: 800,
          fontFamily: "inherit",
          border: "none",
          borderRadius: "999px",
          cursor: disabled ? "default" : "pointer",
          width: "100%",
          transition: "background-color .12s",
        }}
        onClick={selectedStudents.length > 0 ? handleAddStudents : null}
        onMouseEnter={(e) => {
          if (!disabled) e.currentTarget.style.backgroundColor = "#00A396";
        }}
        onMouseLeave={(e) => {
          if (!disabled) e.currentTarget.style.backgroundColor = "#0E141B";
        }}
      >
        {count}명 추가하기
      </button>
      <div
        style={{
          borderRadius: "12px",
          overflow: "auto",
          maxHeight: "470px",
          marginTop: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <colgroup>
            <col style={{ width: "20%" }} />
            <col style={{ width: "20%" }} />
            <col />
            <col style={{ width: "10%" }} />
          </colgroup>
          <thead>
            <tr
              style={{
                borderBottom: "1.5px solid #0E141B",
                textAlign: "left",
                top: 0,
                zIndex: 1,
                backgroundColor: "#FFF",
              }}
            >
              <td style={{ ...thStyle, textAlign: "center" }}>
                {handleSelectAllStudent && (
                  <CustomCheckbox
                    checked={selectedStudents.length > 0}
                    onChange={(e) => handleSelectAllStudent(e.target.checked)}
                  />
                )}
              </td>
              <td style={thStyle}>학년</td>
              <td style={thStyle}>이름</td>
            </tr>
          </thead>
          <tbody style={{ color: "#0E141B" }}>
            {selectedStudents.map((student) => (
              <tr key={student.id} style={{ borderBottom: "1px solid #E6EDEC" }}>
                <td style={{ ...tdStyle, textAlign: "center" }}>
                  <CustomCheckbox
                    checked={selectedStudents.some((s) => s.id === student.id)}
                    onChange={(e) => handleSelectStudent(student)}
                  />
                </td>
                <td style={tdStyle}>{showGrade(student.grade)}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>{student.name}</td>
                <td style={{ color: "#C2452D" }}>
                  {student.is_new == false && <ErrorIcon fontSize="small" />}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectedStudentList;
